import { AttributeType, AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const leader_fio: SugarElementInfo = {
    name: "leader_fio",
    availableChildren: { type: AvailableChildrenType.Any },
    attributes: [{ name: "caption", valueTypes: [AttributeType.String] }],
};
